import { BaseWithId } from './base';

export class Payment extends BaseWithId {

    public client_id: string;
    public case_id: string;

    public type: string;
    public receiver: string;
    public amount: number;
    public received: number;
    public outstanding: number;
    public paid: number;
    public open: number;
    public booking_date: Date | string;
    public payment_target: Date | string;
    public received_percentage: number;
    
    public sort_order: number;

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            type: json && json.type || '',
            booking_date: json && json.booking_date ? new Date(json.booking_date) : null,
            payment_target: json && json.payment_target ? new Date(json.payment_target) : null
        });
    }
}
